import { createArrayWithBracesParser, numberParser, stringParser } from '../inboundParsers';
export const SET_HOLE_CARDS_AFTER_DISCARD_PAYLOAD_DEFINITION = {
    shouldSplitWithBraces: true,
    definitionParts: [
        { name: 'currNumHoleCards', parser: numberParser },
        { name: 'holeCardShorthands', parser: createArrayWithBracesParser(stringParser) },
        { name: 'discardedCardStr', parser: stringParser }
    ]
};
